import Helper from "./common/Helper";
import Popup from "./common/Popup";
import View from "./common/View";
import HelperProject from "./project/_helper";
import HelperTable from "./common/HelperTable";

import tableProjects from "./project/table-projects";
import {formAddWorks} from "./project/form-add-works";
import {tableProjectWorks} from "./project/table-project-works";
import {tableWorkers} from "./workers/table-workers";
import {tableWorker} from "./workers/table-worker";
import {calendarWorker} from "./workers/calendar-worker";
import profile from "./profile/profile";

import tableSettingsServices from "./settings/table-services";
import tableSettingsServicesCategories from "./settings/table-services-category";
import {tableReportWorkers} from "./report-workers";
import {tableReportProjects} from "./report-projects";

(function () {
    $ = jQuery;

    // const Popup = new Popup( Helper, Ajax );

    ESR.Helper = Helper;
    ESR.View = View;
    ESR.Popup = Popup;


    tableSettingsServices(HelperTable);
    tableSettingsServicesCategories(HelperTable);

    tableReportWorkers(HelperTable);
    tableReportProjects(HelperTable);

    tableProjects(HelperTable);
    tableProjectWorks(HelperTable);
    formAddWorks(HelperProject);
    tableWorkers(HelperTable);
    tableWorker(HelperTable);
    calendarWorker($);

    profile();

    const $startDateInput = $('input[name="start_date"]');
    const $endDateInput = $('input[name="end_date"]');

    // Initialize the datepicker
    $('.input-daterange input').each(function() {
        $(this).datepicker({
            language: 'ro',
            todayBtn: true,
            autoclose: true,
            endDate: new Date(),
            format: 'yyyy-mm-dd'
        });
    });

    // Event listener for start date change
    $startDateInput.on('changeDate', function(e) {
        const startDate = e.date;
        const endDate = new Date(startDate);
        endDate.setFullYear(endDate.getFullYear() + 1); // Set the end date to 1 year later

        // Get current end date and check if it exceeds the max interval
        const currentEndDate = $endDateInput.datepicker('getDate');
        if (!currentEndDate || currentEndDate > endDate) {
            $endDateInput.datepicker('setDate', endDate); // Set end date to 1 year from start date
        }
    });

    // Event listener for end date change
    $endDateInput.on('changeDate', function(e) {
        const endDate = e.date;
        const startDate = new Date(endDate);
        startDate.setFullYear(startDate.getFullYear() - 1); // Set the start date to 1 year earlier

        // Get current start date and check if it exceeds the max interval
        const currentStartDate = $startDateInput.datepicker('getDate');
        if (!currentStartDate || currentStartDate < startDate) {
            $startDateInput.datepicker('setDate', startDate); // Set start date to 1 year before end date
        }
    });

})();